import quickPanel from './quickPanel.reducer';

const quickPanelReducers = quickPanel;

export default quickPanelReducers;


// WEBPACK FOOTER //
// ./src/main/quickPanel/store/reducers/index.js